module.exports = __webpack_public_path__ + "img/car.c0d69ba9.png";